import styles from './index.module.sass'

export const AddressNotifier = ({ onClick, label, buttonText }: { onClick: () => void, label: string, buttonText: string }) => {
    return (
        <div className={styles.root}>
            <span>{ label }</span>
            <a href="#" onClick={(e) => {
                e.preventDefault()
                onClick()
            }}>{buttonText}</a>
        </div>
    )
}